import React, {} from "react";
import { } from 'react-redux';
import { useTranslation } from "react-i18next";

import {
  List,
} from '@lockerpm/design';

import {
  ProjectOutlined,
  CloseOutlined
} from "@ant-design/icons";

import itemsComponents from "../../../../../components/items";

const SelectedProjects = (props) => {
  const { TextCopy } = itemsComponents;
  const { t } = useTranslation()
  const {
    selectedProjects = [],
    onRemove = () => {}
  } = props;

  return (
    <List
      itemLayout="horizontal"
      dataSource={selectedProjects}
      renderItem={(p, index) => (
        <List.Item>
          <div
            className="flex items-center justify-between w-full"
            key={index}
          >
            <div className="w-1/2 flex items-center">
              <ProjectOutlined
                className={`mr-2 text-primary`}
                style={{ fontSize: 24 }}
              />
              <div className="flex-1">
                <TextCopy className={`font-semibold`} value={p.name}/>
              </div>
            </div>
            <div className="flex items-center flex-1 text-xs text-black-400">
              <p className="w-1/3">
                {t('secrets.title')}: <span className="font-semibold">
                  <span>{p.total_secret}</span>
                </span>
              </p>
              <p className="font-bold mx-4">|</p>
              <p className="flex-1">
                {t('environments.title')}: <span className="font-semibold">
                  {p.total_environment}
                </span>
              </p>
            </div>
            <div className="cursor-pointer" onClick={() => onRemove(p.id)}>
              <CloseOutlined className="text-danger"/>
            </div>
          </div>
        </List.Item>
      )}
    />
  );
}

export default SelectedProjects;